import type { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { select as typedSelect, call as typedCall } from 'typed-redux-saga';
import { selectProfileOrganizationId } from 'flowhawk-core';

import { apiFetch } from './ApiSaga';
import { setSagaMessage } from '../Redux/ApplicationActions';
import api from '../Services/Api';
import { finishLoading, startLoading } from '../Redux/LoadingActions';
import { receiveAllUsers } from '../Redux/NetworkActions';
import parseProfile from '../Utils/profile';
import type { RootState } from '../Redux';
import type { ApiGetUsersResponse } from '../Utils/apiTypes';
import { ResourceErrorInterface } from 'tg-resources';

export function* getAllUsersSaga(): SagaIterator<void> {
  yield put(startLoading('users'));

  const { result, error } = yield* typedCall(apiFetch<ApiGetUsersResponse>, api.txp.users);

  if (error || !result) {
    if (error instanceof ResourceErrorInterface) {
      if (error.isValidationError) {
        const errorMessage = error;
        yield put(setSagaMessage('', `${errorMessage}`, ''));
      } else if (error.isNetworkError) {
        yield put(setSagaMessage('Loading users failed', 'Are you online?', ''));
      } else {
        yield put(setSagaMessage('Loading users failed', 'Try again later', ''));
      }
    }
    yield put(finishLoading('users'));
  } else {
    const users = result.users;

    const authState = yield* typedSelect((state: RootState) => state.auth);
    const organizationId = selectProfileOrganizationId(authState);

    const organizationUsers = [];
    const otherUsers = [];
    for (let i = 0; i < users.length; i += 1) {
      const userProfile = parseProfile(users[i]);
      if (organizationId && users[i].organization_id === organizationId) {
        organizationUsers.push({ profile: userProfile });
      } else {
        otherUsers.push({ profile: userProfile });
      }
    }

    yield put(receiveAllUsers(organizationUsers, otherUsers));

    yield put(finishLoading('users'));
  }
}
